import CitySEOHead from "@/components/feature/CitySEOHead";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import ShreveportHeroSection from "./components/HeroSection";
import ShreveportStickyNav from "./components/StickyNav";
import ShreveportProcessingTimeSection from "./components/ProcessingTimeSection";
import ShreveportServicesSection from "./components/ServicesSection";
import ShreveportLocalAreaSection from "./components/LocalAreaSection";
import ShreveportTravelTimingSection from "./components/TravelTimingSection";
import ShreveportDestinationsSection from "./components/DestinationsSection";
import ShreveportTestimonialsSection from "./components/TestimonialsSection";
import ShreveportAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import ShreveportComparisonSection from "./components/ComparisonSection";
import ShreveportMistakesSection from "./components/MistakesSection";
import ShreveportHowItWorksSection from "./components/HowItWorksSection";
import ShreveportFAQSection, { faqs } from "./components/FAQSection";
import ShreveportHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import ShreveportFinalCTA from "./components/FinalCTA";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens." },
  { name: "New Passport", description: "First-time passport application assistance." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service." },
  { name: "Child Passport", description: "Passport services for minors under 16." },
  { name: "Name Change", description: "Passport correction and name change service." },
  { name: "Second Passport & Damaged", description: "Second passport issuance and damaged passport replacement." },
];

export default function ShreveportPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Shreveport"
        state="Louisiana"
        stateAbbr="LA"
        route="/shreveport"
        title="Emergency Passport Shreveport, LA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Shreveport, LA — as fast as 24 hours. Barksdale AFB families, casino industry, and oil workers served. A+ BBB rated, registered State Dept. courier serving Shreveport, Bossier City, and Northwest Louisiana."
        geoPlacename="Shreveport, Louisiana"
        geoPosition="32.5252;-93.7502"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Louisiana"
        statePageRoute="/states/louisiana"
      />
      <ShreveportHeroSection />
      <ShreveportStickyNav />
      <ShreveportProcessingTimeSection />
      <ShreveportLocalAreaSection />
      <ShreveportServicesSection />
      <ShreveportTravelTimingSection />
      <ShreveportDestinationsSection />
      <ShreveportTestimonialsSection />
      <ShreveportAcceptanceFacilitiesSection />
      <ShreveportComparisonSection />
      <ShreveportMistakesSection />
      <ShreveportHowItWorksSection />
      <ShreveportFAQSection />
      <ShreveportHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/shreveport" state="LA" />
      <ShreveportFinalCTA />
    </div>
  );
}